import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {IAccount, IAccountsAssignmentRequest} from '@irb/irb-clients/irb-clients.model';
import {
  IPortfolioCreateRequest,
  IAccountToPortfolioAssignment
} from '@irb/irb-create-portfolio/irb-create-portfolio.model';
import {ISecurity} from '@irb/irb-models/irb-models.model';
import {IrbAppEvents} from "@irb/app.events";
import {AppService} from "@irb/app.service";
import {IAlertDialogData} from "@irb/app.model";
import {delay} from "rxjs/operators";

interface IPortfolioExistsActiveResponse {
  pfExists: boolean;
  isActive: boolean;
  allowResurrection: boolean;
  pfId: number;
}

export {
  IPortfolioExistsActiveResponse
};

@Injectable({
  providedIn: 'root'
})
export class IrbCreatePortfolioService {
    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache',
            'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
        })
    };

    constructor(private _http: HttpClient) {
    }

    checkIfPortfolioExists(portfolioName: string): Observable<Object> {
      const options = { headers: this.httpOptions.headers};
      const url = `/irebalone/portfolios/portfolio-exists-active`;
      return this._http.post(url, {portfolioName:portfolioName}, options);
    }

    getUnAssignedAccountCount(): Observable<Object> {
        return this._http.get("/irebalone/accounts/get-unassigned-account-count", this.httpOptions);
    }

    /*getAccountSecurityHoldings(data: Array<IAccount>): Observable<Object> {
      return this._http.post("/irebalone/portfolios/get-account-security-holdings", JSON.stringify(data), this.httpOptions);
    }*/

    addAccToPortEditPage(data: Array<IAccount>): Observable<Object> {
        return this._http.post("/irebalone/portfolios/add-acc-to-port-edit-page", JSON.stringify(data), this.httpOptions);
    }

    /*checkSecurities(data: Array<IAccount>): Observable<Object> {
      return this._http.post("/irebalone/portfolios/check-securities", JSON.stringify(data), this.httpOptions);
    }*/

    addNewSecurityProfiles(data: Array<IAccount>): Observable<Object> {
        return this._http.post("/irebalone/portfolios/add-new-security-profiles-async-call", JSON.stringify(data), this.httpOptions);
    }

    createNewPf(data: IPortfolioCreateRequest): Observable<Object> {
        return this._http.post("/irebalone/portfolios/create-new-pf-async", JSON.stringify(data), this.httpOptions);
    }
   createNewPfAsyncStatus(statusId: any): Observable<Object>  {
       return this._http.get("/irebalone/portfolios/create-new-pf-async-status/"+statusId,  this.httpOptions);
   }
    getUnAssignedAccountSecurityHoldings(): Observable<Object> {
        return this._http.post("/irebalone/accounts/getUnAssignedAccountSecurityHoldings", "", this.httpOptions);
    }

    createPFforUnassignedAccountImport(data: IAccountToPortfolioAssignment): Observable<Object> {
        return this._http.post("/irebalone/accounts/create-pf-for-unassigned-account-import", JSON.stringify(data), this.httpOptions);
    }

    assignAccountsToPortfolio(data: IAccountsAssignmentRequest): Observable<Object> {
        return this._http.post("/irebalone/accounts/assign-accounts-to-portfolio", JSON.stringify(data), this.httpOptions);
    }

    assignAccountsToOwnPortfolio(data: IAccountsAssignmentRequest): Observable<Object> {
        return this._http.post("/irebalone/accounts/assign-accounts-to-own-portfolio", JSON.stringify(data), this.httpOptions);
    }

    assignAccountsToOwnPortfolioStatus(statusId: string): Observable<Object> {
        return this._http.get("/irebalone/accounts/assign-accounts-to-own-portfolio-status/" + statusId, this.httpOptions);
    }

    actionStatusCheck(actionStatusId: any) {
        return this._http.get('/irebalone/accounts/get-pf-for-unassigned-account-import-status/' + actionStatusId).pipe(delay(1000));
        // false && console.log(actionStatusId);
        // return of({
        //     "responseStatus": "SUCCESS",
        //     "responseData": {
        //         "statusId": 251,
        //         "action": "IMPORT_UNASSIGNED_ACCOUNTS",
        //         "moduleName": "ACCOUNT_MODULE",
        //         "reqStatus": "COMPLETED",
        //         "envId": 74830353,
        //         "recievedCount": 1,
        //         "successRecCount": 1,
        //         "failedRecCount": 0,
        //         "failMsg": null,
        //         "requestedBy": "QA_Test123",
        //         "requestedDate": 1689794284962,
        //         "lastModifiedBy": "QA_Test123",
        //         "lastModifiedDate": 1689794285080
        //     },
        //     "responseUtilityMap": null
        // });
    }

    createPFforUnassignedAccountImportAsync(data: any): Observable<Object> {
        return this._http.post("/irebalone/accounts/create-pf-for-unassigned-account-import-asynch", JSON.stringify(data), this.httpOptions);
        // false && console.log(data);
        // return of({
        //     "responseStatus": "SUCCESS",
        //     "responseData": null,
        //     "responseUtilityMap": {
        //         "reqStatus": "IN_PROGRESS",
        //         "statusId": 251
        //     }
        // });
    }
}
